import { css } from '@emotion/react'

export type AppLayoutProps = {
	children: React.ReactNode
}

const AppLayout = ({ children }: AppLayoutProps) => {
	return <div css={wrapperStyle}>{children}</div>
}

export type HeaderProps = {
	children: React.ReactNode
}

const Header = ({ children }: HeaderProps) => {
	return <header css={headerStyle}>{children}</header>
}

export type SideProps = {
	children: React.ReactNode
}

const Side = ({ children }: SideProps) => {
	return <aside css={sideStyle}>{children}</aside>
}

export type MainProps = {
	children: React.ReactNode
}

const Main = ({ children }: MainProps) => {
	return <main css={mainStyle}>{children}</main>
}
export type OutletWrapperProps = {
	children: React.ReactNode
}

const OutletWrapper = ({ children }: OutletWrapperProps) => {
	return <div css={outletWrapperStyle}>{children}</div>
}

export type MainContentProps = {
	children: React.ReactNode
}

const MainContent = ({ children }: MainContentProps) => {
	return <div css={mainContentStyle}>{children}</div>
}

export type FooterProps = {
	children: React.ReactNode
}

const wrapperStyle = css`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
	min-width: 1024px;
`

const headerStyle = css`
	flex: 0 1 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: #fff;
	padding: 0 4.1rem;
	height: 8rem;
`

const sideStyle = css`
	width: 24rem;
	height: 100%;
	position: fixed;
	display: flex;
	top: 0;
	left: 0;
	padding-bottom: 2rem;
`

const mainStyle = css`
	flex: 1 1 auto;
	height: 100%;
	display: flex;
	overflow: hidden;
`

const mainContentStyle = css`
	width: 100%;
	height: 100%;
	flex: 1 1 auto;
	overflow-y: scroll;
	display: flex;
	flex-direction: column;
`

const outletWrapperStyle = css`
	// width: 100%;
	// height: 100%;
	// flex: 1 1 auto;
	// overflow: scroll;
	flex-grow: 1;
`

AppLayout.Header = Header
AppLayout.Side = Side
AppLayout.Main = Main
AppLayout.MainContent = MainContent
AppLayout.OutletWrapper = OutletWrapper

export default AppLayout
